import { categorizeMenuData } from '../utils/menuTags';

// ==================== ИМПОРТ НА СНИМКИ ЗА ПИЦИ ====================
import margaritaImg from '../images/piza Margarita 1.webp';
import margaritaBurataImg from '../images/Margarita s Burata.webp';
import gabenaPicaImg from '../images/Gabena-Pica.webp';
import milanoImg from '../images/Milano.webp';
import formadjoImg from '../images/formadjo.webp';
import kapri4ozaImg from '../images/kapri4oza.webp';
import spanachenaPicaImg from '../images/Spanachena_Pica.webp';
import aliBabaImg from '../images/ali baba copy.webp';
import pepperoniImg from '../images/pepperoni.webp';
import italyImg from '../images/IMG_8265.webp';
import sizilianaImg from '../images/siziliana pikante copy.webp';
import americanoImg from '../images/amerikano.webp';
import kuatroImg from '../images/Kuatro.webp';
import toskanaImg from '../images/toskana copy.webp';
import krenvirshImg from '../images/krenvir6 s 4inia.webp';
import belisimaImg from '../images/Pizza Belisima.webp';
import barbecuImg from '../images/Piza Barbecu.webp';
import biagashtoPileImg from '../images/biaga6to pile s 4inia.webp';
import frutiDiMareImg from '../images/fruti di mare.webp';
import valchaPicaImg from '../images/valcha_pica.webp';
import donVitoImg from '../images/pica Don Vito.webp';
import markoPoloImg from '../images/Piza Marko Polo.webp';
import vegetarianaImg from '../images/Spanachena_Pica.webp';
import proshutoKrudoImg from '../images/proshuto krudo.webp';
import napoliImg from '../images/Roma.webp';
import kebapImg from '../images/pica kebap.webp';
import frenskaPicaImg from '../images/Frenska piza.webp';
import verdiImg from '../images/verdi copy.webp';
import bialaPicaImg from '../images/biala pica.webp';
import carbonaraImg from '../images/pizza carbonara.webp';
import veneciaImg from '../images/venecia.webp';
import havaiImg from '../images/havai.webp';
import diavolskaImg from '../images/Diavolska.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА САЛАТИ ====================
import shopskaImg from '../images/shopska salata.webp';
import ovcharskaImg from '../images/salata ov4arska copy.webp';
import donVitoSaladImg from '../images/Salata DonVito.webp';
import grckaImg from '../images/greek.webp';
import capreseImg from '../images/caprese.webp';
import rodopskaImg from '../images/rodopska salata.webp';
import karakachanskaImg from '../images/karakachanska.webp';
import frenskaSaladImg from '../images/Frenska.webp';
import zelenaSNarImg from '../images/zelena s nar.webp';
import burataSAvokadoImg from '../images/burata s avokado.webp';
import selskaSaladImg from '../images/selska salata.webp';
import svejaSaladImg from '../images/sveja salata.webp';
import zelenaSaladImg from '../images/zelena salata.webp';
import saladNaBabaImg from '../images/salata na baba.webp';
import cezarImg from '../images/cezar.webp';
import nicaImg from '../images/nica.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА ТОПЛИ ПРЕДЯСТИЯ ====================
import tikvichkiImg from '../images/tikvichki s mlecjen sos.webp';
import zelenchuciImg from '../images/zelenchuci na skara.webp';
import gubiSKashkavalImg from '../images/Gubi s kashkaval na furna.webp';
import brokoliFormadjiImg from '../images/Zapecheni kartofi s brokoli.webp';
import orizSManatarkiImg from '../images/oriz s manatarki.webp';
import rizotoImg from '../images/rizoto.webp';
import surcaSGubiImg from '../images/pileshki surca s gubi.webp';
import svinskiDrobImg from '../images/svinski drob.webp';
import hrupkaviPileshkiImg from '../images/hrupkavi pileshki pruchici.webp';
import pileshkiFileSBademiImg from '../images/Pileshko file s bademi.webp';
import pileshkiHapkiImg from '../images/pileshki hapki - file.webp';
import pileshkiKrilcaImg from '../images/pileshki hapki - file.webp';
import pileshkiDrobchetaImg from '../images/prileshki drobcheta.webp';
import pileshkiDrobchetaSelskiImg from '../images/pileshki drobcheta po selski.webp';
import pikantniKartofiImg from '../images/zapecheni pikantni kartofi.webp';
import zadusheniKartofiImg from '../images/zadusheni kartofi.webp';
import domashnoPurjeniKartofiImg from '../images/domashno purjeni kartofi.webp';
import domashnoPurjeniKartofiSSireneImg from '../images/domashno purjeni kartofi sus sirene.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА АЛАМИНУТИ ====================
import pulnenKashkavalSBekonImg from '../images/kashakaval pane.webp';
import kashkavalPaneImg from '../images/Kashkaval pane.webp';
import topeniSirencaImg from '../images/topeni sirenca s kornfleiks.webp';
import sirenePoShopskiImg from '../images/sirene po shopski.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА СУПИ ====================
import taratorImg from '../images/tarator.webp';
import pileshkaSupaIgn from '../images/pileshka supa.webp';
import kartofenaKremSupaIgn from '../images/kartofena krem supa.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА СОСОВЕ ====================
import cesnovSosImg from '../images/hero_pdt_mustard.webp';
import chervenSosImg from '../images/hero_pdt_mustard.webp';
import zehtinImg from '../images/hero_pdt_mustard.webp';
import bialSosImg from '../images/hero_pdt_mustard.webp';
import gorchicaImg from '../images/hero_pdt_mustard.webp';
import sicilianaSosImg from '../images/hero_pdt_mustard.webp';
import pikantenSosImg from '../images/hero_pdt_mustard.webp';
import barbekyuSosImg from '../images/hero_pdt_mustard.webp';
import sladkoKiselSosImg from '../images/hero_pdt_mustard.webp';
import balzamovOcetImg from '../images/hero_pdt_mustard.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА ЗАПЕЧЕНИ КАРТОФИ ====================
import zapecheniSBekonImg from '../images/Zapecheni kartofi s bekon.webp';
import zapecheniSPileImg from '../images/Zapecheni kartofi s pile.webp';
import zapecheniSShunkaImg from '../images/Zapecheni kartofi s shunka.webp';
import zapecheniSSireneImg from '../images/Zapecheni kartofi s sirene.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА ХЛЕБЧЕТА ====================
import chesnovoImg from '../images/chesnovo.webp';
import susamenoImg from '../images/susameno hlebche.webp';
import selskoHlebcheImg from '../images/selsko hlebche.webp';
import kashkavalenoImg from '../images/kashakavaleno.webp';
import italianskoHlebcheImg from '../images/italiansko hlebche.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА ПАСТА ====================
import spagetiFormadjoImg from '../images/spageti formadjo.webp';
import spagetiMatri4anaImg from '../images/spageti matri4ana.webp';
import pastaKarbonaraImg from '../images/pasta karbonara.webp';
import pastaBolonezeImg from '../images/pasta boloneze.webp';
import pastaPoloImg from '../images/pasta polo.webp';
import lazanyaBolonezeImg from '../images/Lazanq boloneze.webp';
import korleoneImg from '../images/korleone.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА МЕСНИ ЯСТИЯ ====================
import pileshkoFileSusSosImg from '../images/pileshko file sus sos ot manatarki i prechurki.webp';
import pileshkoKarenceImg from '../images/pileshko karence s grilovani zelenchuci.webp';
import shnicelImg from '../images/Shnicel.webp';
import svinskoBonFileNaHapkiImg from '../images/svinsko bon file na hapki.webp';
import svinskoBonFileSGabiImg from '../images/svinsko bonfile s gabi.webp';
import svinskiVratniImg from '../images/svinsko-s-luk-i-gbi-16511.webp';
import krehkoTeleshkoImg from '../images/krehko teleshko.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА РИБА И СКАРА ====================
import kombiniranoPlatoImg from '../images/kombinirano plato ot skara.webp';
import menuZaDvamaImg from '../images/menu_za_Dvama.webp';
import djolanImg from '../images/djolan.webp';
import svinskiRebraImg from '../images/svinski marinovani reburca.webp';
import teleshkiKiuftencaImg from '../images/teleshki kiuftenca.webp';
import adanaKebapImg from '../images/Adana kebap.webp';
import miniTeleshkiKebapchetaImg from '../images/kebapcheta.webp';
import bqlaRibaPaneImg from '../images/bqla riba pane.webp';
import pastarvaImg from '../images/pastarva.webp';
import paniraniKalmariImg from '../images/panirani kalmari.webp';
import lavrakImg from '../images/lavrak na skara.webp';
import pileshkaMeshanaSkaraImg from '../images/pileshka meshana skara.webp';
import svinskaMeshanaSkaraImg from '../images/svinska meshana skara.webp';
import pileshkaPurjolaOtButcheImg from '../images/pileshka purjola ot butche.webp';
import pileshkaPurjolaOtFileImg from '../images/pileshka purjola ot butche.webp';
import svinskaVratnaPurjolaImg from '../images/svinska vratna purjola.webp';
import kebapcheImg from '../images/kebapche.webp';
import kiuftemImg from '../images/kiufte.webp';
import pileshkoShishcheImg from '../images/pileshko shishche.webp';
import svinskoShishcheImg from '../images/svinsko shishche.webp';
import kombiniranSachImg from '../images/kombiniran sach.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА ДЕСЕРТИ ====================
import chiizKeikImg from '../images/chiiz keik.webp';
import kremKaramelImg from '../images/Krem karamel.webp';
import mle4naNasladaImg from '../images/mle4na naslada.webp';
import plodovaSalataImg from '../images/plodova salata.webp';
import melbaImg from '../images/melba.webp';
import sladoledImg from '../images/sladoled.webp';
import palachinkaImg from '../images/palachinka.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА ДОБАВКИ ====================
import alergeniImg from '../images/IconoAlergenoDioxidoAzufreSulfitosSulfurDioxideSulphites.webp';
import donVitoFallbackImg from '../images/don-vito-fallback.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА НАПИТКИ ====================
// Безалкохолни
import freshPortokalImg from '../images/fresh_portokal.webp';
import domashnaLimonadaImg from '../images/domashna_limonada.webp';
import AiryanImg from '../images/don-vito-fallback.webp';
import cocaColaImg from '../images/coca_cola.webp';
import cocaColaZeroImg from '../images/coca_cola_zero.webp';
import fantaImg from '../images/fanta.webp';
import spriteImg from '../images/sprite.webp';
import schweppesImg from '../images/schweppes.webp';
import schweppesSodaImg from '../images/schweppes_soda.webp';
import cappyImg from '../images/cappy.webp';
import cappyLimonadaImg from '../images/cappy_limonada.webp';
import fuzeTeaImg from '../images/fuze_tea.webp';
import bankyaWaterImg from '../images/bankya_water.webp';

// Топли напитки
import lavazzaImg from '../images/lavazza.webp';
import cappuccinoImg from '../images/cappuccino.webp';
import viennaCoffeeImg from '../images/vienna_coffee.webp';
import icedCoffeeImg from '../images/iced_coffee.webp';
import milkWithNescafeImg from '../images/milk_nescafe.webp';
import teaImg from '../images/tea.webp';
import honeyImg from '../images/honey.webp';
import creamImg from '../images/don-vito-fallback.webp';

// Алкохолни напитки
import peshteraRakiaImg from '../images/peshteraRakia.webp';
import troyanskaRakiaImg from '../images/troyanskaRakia.webp';
import straldzhanskaRakiaImg from '../images/straldzhanskaRakia.webp';
import burgaskaRakiaImg from '../images/burgaskaRakia.webp';
import burgas63Img from '../images/burgas63Img.webp';
import slivenskaperlaImg from '../images/slivenskaperla.webp';
import absolutVodkaImg from '../images/absolutVodka.webp';
import finlandiaVodkaImg from '../images/finlandiaVodka.webp';
import bulgarianVodkaImg from '../images/bulgarianVodka.webp';
import beefeaterGinImg from '../images/beefeaterGin.webp';
import bulgarianGinImg from '../images/bulgarianGin.webp';
import johnnieWalkerImg from '../images/johnnieWalker.webp';
import johnnieWalker12Img from '../images/johnnieWalker12.webp';
import tullamoreDewImg from '../images/tullamoreDew.webp';
import jamesonImg from '../images/jameson.webp';
import jackDanielsImg from '../images/jackDaniels.webp';
import peshteraMastikaImg from '../images/peshteraMastika.webp';
import peshteraMenthaImg from '../images/peshteraMentha.webp';
import ouzoPlomariImg from '../images/ouzoPlomari.webp';
import ouzoBottleImg from '../images/ouzoBottle.webp';
import bulgarianCognacImg from '../images/bulgarianCognac.webp';

// Бира
import staropramenDraftImg from '../images/staropramen.webp';
import staropramenDarkDraftImg from '../images/staropramen_dark.webp';
import stellaArtoisDraftImg from '../images/stella_artois.webp';
import kamenitzaImg from '../images/kamenitza.webp';
import burgaskoImg from '../images/burgasko.webp';
import becksNonAlcoholicImg from '../images/becks.webp';
import staropramenImg from '../images/staropramen.webp';
import staropramenDarkImg from '../images/staropramen_dark.webp';
import stellaArtoisImg from '../images/stella_artois.webp';
import leffeImg from '../images/leffe.webp';
import heinekenImg from '../images/heineken.webp';
import czechBeerImg from '../images/staropramen.webp';

// ==================== ИМПОРТ НА СНИМКИ ЗА ВИНА ====================
import whitepapillonImg from '../images/whitepapillon.webp';
import whitelogodageblancImg from '../images/whitelogodageblanc.webp';
import whitelogodagegrigioImg from '../images/whitelogodagegrigio.webp';
import redpapillonImg from '../images/redpapillon.webp';
import redlogodagecabernetImg from '../images/redlogodagecabernet.webp';
import redlogodage55Img from '../images/redlogodage55.webp';
import rosepapillonImg from '../images/rosepapillon.webp';
import whitedraftSAUVIGNONBLANCImg from '../images/Logodaj_Wine.webp';
import reddraftCABERNETANDMERLOTImg from '../images/Logodaj_Wine.webp';

// ==================== MENU DATA ====================
const uncategorizedMenuData = {
  pizza: [
    {
      id: "pizza-1",
      name_bg: "МАРГАРИТА С ПРЕСНИ ДОМАТИ",
      name_en: "MARGHERITA WITH FRESH TOMATOES",
      description_bg: "доматен сос, бяло сирене, пресни домати, кашкавал",
      description_en: "tomato sauce, white cheese, fresh tomatoes, yellow cheese",
      prices: { "24см": 5.49, "30см": 7.49 },
      image: margaritaImg,
      tags: []
    },
    {
      id: "pizza-2",
      name_bg: "МАРГАРИТА С МОЦАРЕЛА И РУКОЛА",
      name_en: "MARGHERITA WITH MOZZARELLA AND ARUGULA",
      description_bg: "доматен сос, бяло сирене, моцарела, рукола, кашкавал",
      description_en: "tomato sauce, white cheese, mozzarella, arugula, yellow cheese",
      prices: { "24см": 6.49, "30см": 7.99 },
      image: margaritaBurataImg,
      tags: ["top"]
    },
    {
      id: "pizza-3",
      name_bg: "ГЪБЕНА ПИЦА",
      name_en: "MUSHROOM PIZZA",
      description_bg: "доматен сос, пресни гъби, кашкавал",
      description_en: "tomato sauce, fresh mushrooms, yellow cheese",
      prices: { "24см": 5.99, "30см": 7.49 },
      image: gabenaPicaImg,
      tags: []
    },
    {
      id: "pizza-4",
      name_bg: "МИЛАНО",
      name_en: "MILANO",
      description_bg: "доматен сос, шунка, гъби, кашкавал",
      description_en: "tomato sauce, ham, mushrooms, yellow cheese",
      prices: { "24см": 6.49, "30см": 8.49 },
      image: milanoImg,
      tags: []
    },
    {
      id: "pizza-5",
      name_bg: "ФОРМАДЖО",
      name_en: "FORMAGGIO",
      description_bg: "доматен сос, бяло сирене, топено сирене, рокфор, кашкавал",
      description_en: "tomato sauce, white cheese, melted cheese, roquefort, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: formadjoImg,
      tags: ["top"]
    },
    {
      id: "pizza-6",
      name_bg: "КАПРИЧОЗА",
      name_en: "CAPRICCIOSA",
      description_bg: "доматен сос, шунка, гъби, яйце, домати, кашкавал",
      description_en: "tomato sauce, ham, mushrooms, egg, tomatoes, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: kapri4ozaImg,
      tags: []
    },
    {
      id: "pizza-7",
      name_bg: "СПАНАЧЕНА ПИЦА",
      name_en: "SPINACH PIZZA",
      description_bg: "доматен сос, спанак, сирене, яйце, кашкавал",
      description_en: "tomato sauce, spinach, cheese, egg, yellow cheese",
      prices: { "24см": 6.49, "30см": 8.49 },
      image: spanachenaPicaImg,
      tags: []
    },
    {
      id: "pizza-8",
      name_bg: "АЛИ БАБА",
      name_en: "ALI BABA",
      description_bg: "доматен сос, шунка, луканка, кисели краставички, кашкавал",
      description_en: "tomato sauce, ham, sausage, pickles, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: aliBabaImg,
      tags: []
    },
    {
      id: "pizza-9",
      name_bg: "ПЕПЕРОНИ",
      name_en: "PEPPERONI",
      description_bg: "доматен сос, пеперони, кашкавал",
      description_en: "tomato sauce, pepperoni, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: pepperoniImg,
      tags: ["top", "spicy"]
    },
    {
      id: "pizza-10",
      name_bg: "ИТАЛИЯ",
      name_en: "ITALY",
      description_bg: "доматен сос, шунка, пеперони, яйце, кашкавал",
      description_en: "tomato sauce, ham, pepperoni, egg, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: italyImg,
      tags: []
    },
    {
      id: "pizza-11",
      name_bg: "СИЦИЛИАНА ПИКАНТЕ",
      name_en: "SICILIANA PICANTE",
      description_bg: "доматен сос, шунка, чушки, лют пипер, кашкавал",
      description_en: "tomato sauce, ham, peppers, chili, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: sizilianaImg,
      tags: ["spicy"]
    },
    {
      id: "pizza-12",
      name_bg: "АМЕРИКАНО",
      name_en: "AMERICANO",
      description_bg: "доматен сос, шунка, кисели краставички, кашкавал",
      description_en: "tomato sauce, ham, pickles, yellow cheese",
      prices: { "24см": 6.49, "30см": 8.49 },
      image: americanoImg,
      tags: []
    },
    {
      id: "pizza-13",
      name_bg: "КУАТРО СТАДЖОНИ",
      name_en: "QUATTRO STAGIONI",
      description_bg: "доматен сос, шунка, царевица, пилешка шунка, кисели краставички, гъби, кашкавал",
      description_en: "tomato sauce, ham, corn, chicken ham, pickles, mushrooms, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: kuatroImg,
      tags: []
    },
    {
      id: "pizza-14",
      name_bg: "ТОСКАНА",
      name_en: "TOSCANA",
      description_bg: "доматен сос, шунка, кисели краставички, топено сирене, гъби, кашкавал",
      description_en: "tomato sauce, ham, pickles, melted cheese, mushrooms, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: toskanaImg,
      tags: []
    },
    {
      id: "pizza-15",
      name_bg: "КРЕНВИРШ ПИЦА",
      name_en: "HOT DOG PIZZA",
      description_bg: "доматен сос, кренвирш, кашкавал",
      description_en: "tomato sauce, hot dog, yellow cheese",
      prices: { "24см": 6.49, "30см": 8.49 },
      image: krenvirshImg,
      tags: []
    },
    {
      id: "pizza-16",
      name_bg: "БЕЛИСИМА",
      name_en: "BELLISSIMA",
      description_bg: "сметана, пилешко филе, яйца, кашкавал",
      description_en: "cream, chicken fillet, eggs, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: belisimaImg,
      tags: []
    },
    {
      id: "pizza-17",
      name_bg: "БАРБЕКЮ ПИЦА",
      name_en: "BARBECUE PIZZA",
      description_bg: "барбекю сос, моцарела, бекон, пилешко филе, кашкавал",
      description_en: "barbecue sauce, mozzarella, bacon, chicken fillet, yellow cheese",
      prices: { "24см": 7.49, "30см": 9.49 },
      image: barbecuImg,
      tags: ["top"]
    },
    {
      id: "pizza-18",
      name_bg: "БЯГАЩО ПИЛЕ",
      name_en: "RUNNING CHICKEN",
      description_bg: "доматен сос, топено сирене, пушено пиле, царевица, кашкавал",
      description_en: "tomato sauce, melted cheese, smoked chicken, corn, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: biagashtoPileImg,
      tags: []
    },
    {
      id: "pizza-19",
      name_bg: "ФРУТИ ДИ МАРЕ",
      name_en: "FRUTTI DI MARE",
      description_bg: "доматен сос, риба тон, скарди, калмари, лимон, кашкавал",
      description_en: "tomato sauce, tuna, scad, calamari, lemon, yellow cheese",
      prices: { "24см": 7.99, "30см": 9.99 },
      image: frutiDiMareImg,
      tags: ["top"]
    },
    {
      id: "pizza-20",
      name_bg: "ВЪЛЧА ПИЦА",
      name_en: "WOLF PIZZA",
      description_bg: "доматен сос, шунка, пилешка шунка, луканка, бекон, кашкавал",
      description_en: "tomato sauce, ham, chicken ham, sausage, bacon, yellow cheese",
      prices: { "24см": 7.49, "30см": 9.49 },
      image: valchaPicaImg,
      tags: []
    },
    {
      id: "pizza-21",
      name_bg: "ДОН ВИТО",
      name_en: "DON VITO",
      description_bg: "доматен сос, сирене, чушки, гъби, царевица, шунка, луканка, кашкавал",
      description_en: "tomato sauce, cheese, peppers, mushrooms, corn, ham, sausage, yellow cheese",
      prices: { "24см": 7.49, "30см": 9.49 },
      image: donVitoImg,
      tags: ["top"]
    },
    {
      id: "pizza-22",
      name_bg: "МАРКО ПОЛО",
      name_en: "MARCO POLO",
      description_bg: "доматен сос, пилешка шунка, кисели краставички, гъби, кашкавал",
      description_en: "tomato sauce, chicken ham, pickles, mushrooms, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: markoPoloImg,
      tags: []
    },
    {
      id: "pizza-23",
      name_bg: "ВЕГЕТАРИАНА",
      name_en: "VEGETARIANA",
      description_bg: "доматен сос, гъби, царевица, чушки, моркови, зеле, лук, домати, краставички, магданоз, кашкавал",
      description_en: "tomato sauce, mushrooms, corn, peppers, carrots, cabbage, onion, tomatoes, pickles, parsley, yellow cheese",
      prices: { "24см": 6.49, "30см": 8.49 },
      image: vegetarianaImg,
      tags: []
    },
    {
      id: "pizza-24",
      name_bg: "ПРОШУТО КРУДО",
      name_en: "PROSCIUTTO CRUDO",
      description_bg: "доматен сос, прошуто, пресни домати, кашкавал",
      description_en: "tomato sauce, prosciutto, fresh tomatoes, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: proshutoKrudoImg,
      tags: ["top"]
    },
    {
      id: "pizza-25",
      name_bg: "НАПОЛИ",
      name_en: "NAPOLI",
      description_bg: "доматен сос, пеперони, синьо сирене, печена чушка, кашкавал",
      description_en: "tomato sauce, pepperoni, blue cheese, roasted pepper, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: napoliImg,
      tags: []
    },
    {
      id: "pizza-26",
      name_bg: "КЕБАП ПИЦА",
      name_en: "KEBAP PIZZA",
      description_bg: "доматен сос, бекон, печено пилешко филе, чушки, чубрица, кашкавал",
      description_en: "tomato sauce, bacon, roasted chicken fillet, peppers, savory, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: kebapImg,
      tags: []
    },
    {
      id: "pizza-27",
      name_bg: "ФРЕНСКА ПИЦА",
      name_en: "FRENCH PIZZA",
      description_bg: "сметана, бяло сирене, синьо сирене, луканка, кашкавал",
      description_en: "cream, white cheese, blue cheese, sausage, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: frenskaPicaImg,
      tags: []
    },
    {
      id: "pizza-28",
      name_bg: "ВЕРДИ",
      name_en: "VERDI",
      description_bg: "доматен сос, топено сирене, шунка, гъби, царевица, кашкавал",
      description_en: "tomato sauce, melted cheese, ham, mushrooms, corn, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: verdiImg,
      tags: []
    },
    {
      id: "pizza-29",
      name_bg: "БЯЛА ПИЦА",
      name_en: "WHITE PIZZA",
      description_bg: "сметана, пилешка шунка, сирене, топено сирене, яйце, кашкавал",
      description_en: "cream, chicken ham, cheese, melted cheese, egg, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: bialaPicaImg,
      tags: []
    },
    {
      id: "pizza-30",
      name_bg: "КАРБОНАРА ПИЦА",
      name_en: "CARBONARA PIZZA",
      description_bg: "сметана, шунка, яйце, кашкавал",
      description_en: "cream, ham, egg, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: carbonaraImg,
      tags: []
    },
    {
      id: "pizza-31",
      name_bg: "ВЕНЕЦИЯ",
      name_en: "VENICE",
      description_bg: "доматен сос, бекон, гъби, яйце, лук, кашкавал",
      description_en: "tomato sauce, bacon, mushrooms, egg, onion, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: veneciaImg,
      tags: []
    },
    {
      id: "pizza-32",
      name_bg: "ХАВАЙ ПИЦА",
      name_en: "HAWAIIAN PIZZA",
      description_bg: "доматен сос, шунка, ананас, кашкавал",
      description_en: "tomato sauce, ham, pineapple, yellow cheese",
      prices: { "24см": 6.99, "30см": 8.99 },
      image: havaiImg,
      tags: []
    },
    {
      id: "pizza-33",
      name_bg: "ДЯВОЛСКА ПИЦА",
      name_en: "DEVIL'S PIZZA",
      description_bg: "доматен сос, шунка, лют пипер, кашкавал",
      description_en: "tomato sauce, ham, chili pepper, yellow cheese",
      prices: { "24см": 6.49, "30см": 8.49 },
      image: diavolskaImg,
      tags: ["spicy"]
    }
  ],

  // ==================== ДЕТСКО МЕНЮ ====================
  kids_menu: [
    {
      id: "kids-pizza",
      name_bg: "ДЕТСКА ПИЦА",
      name_en: "KIDS PIZZA",
      description_bg: "доматен сос, шунка и кашкавал",
      description_en: "tomato sauce, ham and yellow cheese",
      prices: { default: 0 },
      image: milanoImg,
      tags: [],
      includedInKidsMenu: true
    },
    {
      id: "kids-juice",
      name_bg: "НАТУРАЛЕН СОК CAPPY",
      name_en: "CAPPY NATURAL JUICE",
      description_bg: "натурален сок Cappy по избор",
      description_en: "Cappy natural juice of your choice",
      prices: { default: 0 },
      image: cappyImg,
      tags: [],
      includedInKidsMenu: true
    },
    {
      id: "kids-pancake",
      name_bg: "ПАЛАЧИНКА",
      name_en: "PANCAKE",
      description_bg: "палачинка, включена в детското меню",
      description_en: "pancake included in the kids menu",
      prices: { default: 0 },
      image: palachinkaImg,
      tags: [],
      includedInKidsMenu: true
    },
    {
      id: "kids-gift",
      name_bg: "ПОДАРЪК",
      name_en: "GIFT",
      description_bg: "подарък от Don Vito",
      description_en: "a gift from Don Vito",
      prices: { default: 0 },
      image: donVitoFallbackImg,
      imageContain: true,
      tags: [],
      includedInKidsMenu: true
    }
  ],

  // ==================== САЛАТИ ====================
  salads: [
    {
      id: "salad-1",
      name_bg: "ШОПСКА САЛАТА",
      name_en: "SHOPSKA SALAD",
      description_bg: "домати, краставици, сирене, лук, чушки, магданоз, маслина",
      description_en: "tomatoes, cucumbers, cheese, onion, peppers, parsley, olive",
      prices: { "400г": 4.99 },
      image: shopskaImg,
      tags: ["top"]
    },
    {
      id: "salad-2",
      name_bg: "ОВЧАРСКА САЛАТА",
      name_en: "SHEPHERD'S SALAD",
      description_bg: "домати, краставици, шунка, лук, чушки, гъби, яйце, сирене, маслини, магданоз",
      description_en: "tomatoes, cucumbers, ham, onion, peppers, mushrooms, egg, cheese, olives, parsley",
      prices: { "450г": 5.99 },
      image: ovcharskaImg,
      tags: ["top"]
    },
    {
      id: "salad-3",
      name_bg: "ДОН ВИТО САЛАТА",
      name_en: "DON VITO SALAD",
      description_bg: "домати, краставици, печена чушка, кашкавал, сирене, зеле, моркови, маслина, майонезен сос",
      description_en: "tomatoes, cucumbers, roasted pepper, yellow cheese, cheese, cabbage, carrots, olive, mayonnaise sauce",
      prices: { "400г": 6.49 },
      image: donVitoSaladImg,
      tags: []
    },
    {
      id: "salad-4",
      name_bg: "ГРЪЦКА САЛАТА",
      name_en: "GREEK SALAD",
      description_bg: "домати, краставици, лук, сирене, маслини, чушка, риган",
      description_en: "tomatoes, cucumbers, onion, cheese, olives, pepper, oregano",
      prices: { "400г": 5.99 },
      image: grckaImg,
      tags: ["top"]
    },
    {
      id: "salad-5",
      name_bg: "КАПРЕЗЕ",
      name_en: "CAPRESE",
      description_bg: "белени домати, моцарела, маслина, песто сос",
      description_en: "peeled tomatoes, mozzarella, olive, pesto sauce",
      prices: { "350г": 6.49 },
      image: capreseImg,
      tags: ["top"]
    },
    {
      id: "salad-6",
      name_bg: "РОДОПСКА САЛАТА",
      name_en: "RHODOPE SALAD",
      description_bg: "белени домати, печени чушки, сирене, маслина",
      description_en: "peeled tomatoes, roasted peppers, cheese, olive",
      prices: { "350г": 5.99 },
      image: rodopskaImg,
      tags: []
    },
    {
      id: "salad-7",
      name_bg: "КАРАКАЧАНСКА САЛАТА",
      name_en: "KARAKACHANSKA SALAD",
      description_bg: "домати, печени чушки, сирене, яйце, магданоз, лук, маслина",
      description_en: "tomatoes, roasted peppers, cheese, egg, parsley, onion, olive",
      prices: { "350г": 5.99 },
      image: karakachanskaImg,
      tags: []
    },
    {
      id: "salad-8",
      name_bg: "ФРЕНСКА САЛАТА",
      name_en: "FRENCH SALAD",
      description_bg: "домати, краставици, пилешка шунка, яйце, гъби, кашкавал, специален сос, маслина",
      description_en: "tomatoes, cucumbers, chicken ham, egg, mushrooms, yellow cheese, special sauce, olive",
      prices: { "430г": 5.99 },
      image: frenskaSaladImg,
      tags: []
    },
    {
      id: "salad-9",
      name_bg: "ЗЕЛЕНА САЛАТА С НАР",
      name_en: "GREEN SALAD WITH POMEGRANATE",
      description_bg: "айсберг, синьо сирене, чедър, стафиди, пармезан, нар, ябълка, дресинг",
      description_en: "iceberg, blue cheese, cheddar, raisins, parmesan, pomegranate, apple, dressing",
      prices: { "280г": 6.99 },
      image: zelenaSNarImg,
      tags: ["top"]
    },
    {
      id: "salad-10",
      name_bg: "МОЦАРЕЛА С АВОКАДО",
      name_en: "MOZZARELLA WITH AVOCADO",
      description_bg: "моцарела, белени домати, авокадо, рукола, балсамов дресинг, песто",
      description_en: "mozzarella, peeled tomatoes, avocado, arugula, balsamic dressing, pesto",
      prices: { "300г": 6.99 },
      image: burataSAvokadoImg,
      tags: ["top"]
    },
    {
      id: "salad-11",
      name_bg: "СЕЛСКА САЛАТА",
      name_en: "COUNTRY SALAD",
      description_bg: "червен лук, боб, домати, краставици, печено сирене, печени чушки, маслини, джоджен, магданоз, зехтин",
      description_en: "red onion, beans, tomatoes, cucumbers, roasted cheese, roasted peppers, olives, mint, parsley, olive oil",
      prices: { "380г": 5.99 },
      image: selskaSaladImg,
      tags: []
    },
    {
      id: "salad-12",
      name_bg: "СВЕЖА САЛАТА",
      name_en: "FRESH SALAD",
      description_bg: "листни салати, гриловано халуми, домати, сушени домати, орехов дресинг, пармезан",
      description_en: "leafy salads, grilled halloumi, tomatoes, sun-dried tomatoes, walnut dressing, parmesan",
      prices: { "280г": 6.99 },
      image: svejaSaladImg,
      tags: []
    },
    {
      id: "salad-13",
      name_bg: "ЗЕЛЕНА САЛАТА",
      name_en: "GREEN SALAD",
      description_bg: "зелена салата, краставици, репичка, лук, маслина, яйце",
      description_en: "green salad, cucumbers, radish, onion, olive and egg",
      prices: { "300г": 5.49 },
      image: zelenaSaladImg,
      tags: []
    },
    {
      id: "salad-14",
      name_bg: "САЛАТА НА БАБА",
      name_en: "GRANDMOTHER'S SALAD",
      description_bg: "снежанка, печени чушки, домати, хлебче",
      description_en: "yogurt-cucumber dip, roasted peppers, tomatoes, bread",
      prices: { "350г": 6.49 },
      image: saladNaBabaImg,
      tags: []
    },
    {
      id: "salad-15",
      name_bg: "ЦЕЗАР САЛАТА",
      name_en: "CAESAR SALAD",
      description_bg: "домати, краставици, зелена салата, печено пилешко филе, пармезан, маслина, дресинг",
      description_en: "tomatoes, cucumbers, green salad, roasted chicken fillet, parmesan, olive, dressing",
      prices: { "370г": 6.99 },
      image: cezarImg,
      tags: ["top"]
    },
    {
      id: "salad-16",
      name_bg: "НИЦА САЛАТА",
      name_en: "NICE SALAD",
      description_bg: "маруля, риба тон, синьо сирене, краставици, домати, лук, маслина",
      description_en: "lettuce, tuna, blue cheese, cucumbers, tomatoes, onion, olive",
      prices: { "390г": 6.99 },
      image: nicaImg,
      tags: []
    }
  ],

  // ==================== ТОПЛИ ПРЕДЯСТИЯ ====================
  appetizers: [
    { id: "app-1", name_bg: "ТИКВИЧКИ С МЛЕЧЕН СОС", name_en: "ZUCCHINI WITH MILK SAUCE", description_bg: "хрупкави пържени тиквички с млечен сос", description_en: "crispy fried zucchini with milk sauce", prices: { "350г": 5.49 }, image: tikvichkiImg, tags: [] },
    { id: "app-2", name_bg: "ЗЕЛЕНЧУЦИ НА СКАРА", name_en: "GRILLED VEGETABLES", description_bg: "асортимент от сезонни зеленчуци на скара", description_en: "assorted seasonal grilled vegetables", prices: { "300г": 6.49 }, image: zelenchuciImg, tags: [] },
    { id: "app-3", name_bg: "ГЪБИ С КАШКАВАЛ НА ФУРНА", name_en: "BAKED MUSHROOMS WITH CHEESE", description_bg: "свежи гъби, печени с кашкавал", description_en: "fresh baked mushrooms with yellow cheese", prices: { "300г": 6.99 }, image: gubiSKashkavalImg, tags: [] },
    { id: "app-4", name_bg: "БРОКОЛИ ФОРМАДЖИ", name_en: "BROCCOLI FORMAGGIO", description_bg: "броколи със сметана, рокфор, шунка и кашкавал", description_en: "broccoli with cream, roquefort, ham and yellow cheese", prices: { "500г": 6.99 }, image: brokoliFormadjiImg, tags: [] },
    { id: "app-5", name_bg: "РИЗОТО С МАНАТАРКИ", name_en: "MUSHROOM RISOTTO", description_bg: "кремообразен ориз с манатарки и пармезан", description_en: "creamy risotto with mushrooms and parmesan", prices: { "350г": 7.49 }, image: orizSManatarkiImg, tags: ["top"] },
    { id: "app-6", name_bg: "ЗЕЛЕНЧУКОВ РИЗОТО", name_en: "VEGETABLE RISOTTO", description_bg: "ризото със сезонни зеленчуци", description_en: "risotto with seasonal vegetables", prices: { "500г": 6.49 }, image: rizotoImg, tags: [] },
    { id: "app-7", name_bg: "ПИЛЕШКИ РИЗОТО", name_en: "CHICKEN RISOTTO", description_bg: "ризото с пилешко месо и зеленчуци", description_en: "risotto with chicken and vegetables", prices: { "500г": 6.99 }, image: rizotoImg, tags: [] },
    { id: "app-8", name_bg: "ПИЛЕШКИ СЪРЦА С ГЪБИ", name_en: "CHICKEN HEARTS WITH MUSHROOMS", description_bg: "пилешки сърца и гъби, задушени в масло", description_en: "chicken hearts and mushrooms sautéed in butter", prices: { "350г": 6.99 }, image: surcaSGubiImg, tags: [] },
    { id: "app-9", name_bg: "СВИНСКИ ДРОБ В МАСЛО", name_en: "PORK LIVER IN BUTTER", description_bg: "пържен свински дроб с масло, бяло вино и подправки", description_en: "fried pork liver with butter, white wine and spices", prices: { "280г": 6.49 }, image: svinskiDrobImg, tags: [] },
    { id: "app-10", name_bg: "ХРУПКАВИ ПИЛЕШКИ ФИЛЕНЦА", name_en: "CRISPY CHICKEN FILLETS", description_bg: "панирани пилешки филенца с картофи", description_en: "breaded chicken fillets with potatoes", prices: { "180г": 6.99 }, image: hrupkaviPileshkiImg, tags: ["top"] },
    { id: "app-11", name_bg: "ПИЛЕШКИ ФИЛЕ С БАДЕМИ", name_en: "CHICKEN FILLET WITH ALMONDS", description_bg: "пилешко филе с хрупкави бадеми", description_en: "chicken fillet with crispy almonds", prices: { "180г": 6.99 }, image: pileshkiFileSBademiImg, tags: [] },
    { id: "app-12", name_bg: "ПИЛЕШКИ ХАПКИ", name_en: "CHICKEN BITES", description_bg: "хрупкави пилешки хапки с подправки", description_en: "crispy spiced chicken bites", prices: { "200г": 6.49 }, image: pileshkiHapkiImg, tags: [] },
    { id: "app-13", name_bg: "ПИЛЕШКИ КРИЛЦА", name_en: "CHICKEN WINGS", description_bg: "пилешки крилца - пържени или на скара", description_en: "chicken wings - fried or grilled", prices: { "300г": 5.99 }, image: pileshkiKrilcaImg, tags: ["top"] },
    { id: "app-14", name_bg: "ПИЛЕШКИ ДРОБЧЕТА", name_en: "CHICKEN GIBLETS", description_bg: "пилешки дробчета на скара или тиган", description_en: "chicken giblets grilled or pan-fried", prices: { "220г": 5.99 }, image: pileshkiDrobchetaImg, tags: [] },
    { id: "app-15", name_bg: "ПИЛЕШКИ ДРОБЧЕТА ПО СЕЛСКИ", name_en: "COUNTRY CHICKEN GIBLETS", description_bg: "пилешки дробчета в доматен сос", description_en: "chicken giblets in tomato sauce", prices: { "350г": 6.49 }, image: pileshkiDrobchetaSelskiImg, tags: [] },
    { id: "app-16", name_bg: "ПИКАНТНИ КАРТОФИ", name_en: "SPICY POTATOES", description_bg: "хрупкави картофи с пикантни подправки", description_en: "crispy potatoes with spicy seasoning", prices: { "200г": 3.99 }, image: pikantniKartofiImg, tags: ["spicy"] },
    { id: "app-17", name_bg: "ЗАДУШЕНИ КАРТОФИ", name_en: "STEWED POTATOES", description_bg: "задушени картофи с ароматни подправки", description_en: "stewed potatoes with aromatic spices", prices: { "300г": 3.99 }, image: zadusheniKartofiImg, tags: [] },
    { id: "app-18", name_bg: "ДОМАШНИ ПЪРЖЕНИ КАРТОФИ", name_en: "HOMEMADE FRIES", description_bg: "домашни пържени картофи", description_en: "homemade french fries", prices: { "180г": 3.49 }, image: domashnoPurjeniKartofiImg, tags: [] },
    { id: "app-19", name_bg: "ДОМАШНИ КАРТОФИ СЪС СИРЕНЕ", name_en: "HOMEMADE FRIES WITH CHEESE", description_bg: "домашни пържени картофи с поръсено сирене", description_en: "homemade fries topped with cheese", prices: { "200г": 3.99 }, image: domashnoPurjeniKartofiSSireneImg, tags: [] }
  ],

  // ==================== АЛАМИНУТИ ====================
  alaminute: [
    { id: "ala-1", name_bg: "ПЪЛНЕН КАШКАВАЛ С БЕКОН", name_en: "STUFFED CHEESE WITH BACON", description_bg: "кашкавал, пълнен с бекон и печен", description_en: "yellow cheese stuffed with bacon and baked", prices: { "280г": 6.99 }, image: pulnenKashkavalSBekonImg, tags: [] },
    { id: "ala-2", name_bg: "КАШКАВАЛ ПАНЕ", name_en: "BREADED CHEESE", description_bg: "паниран кашкавал с пържени картофи и бял сос", description_en: "breaded yellow cheese with fries and white sauce", prices: { "350г": 6.99 }, image: kashkavalPaneImg, tags: [] },
    { id: "ala-3", name_bg: "ТОПЕНИ СИРЕНЦА С КОРНФЛЕЙКС", name_en: "MELTED CHEESE WITH CORNFLAKES", description_bg: "топени сиренца с хрупкава коричка от корнфлейкс", description_en: "melted cheese with crispy cornflake crust", prices: { "200г": 5.99 }, image: topeniSirencaImg, tags: [] },
    { id: "ala-4", name_bg: "СИРЕНЕ ПО ШОПСКИ", name_en: "SHOPSKA CHEESE", description_bg: "печено сирене с домати и чушки", description_en: "baked cheese with tomatoes and peppers", prices: { "470г": 5.49 }, image: sirenePoShopskiImg, tags: ["top"] }
  ],

  // ==================== СУПИ ====================
  soups: [
    { id: "soup-1", name_bg: "ТАРАТОР", name_en: "TARATOR", description_bg: "студена супа от кисело мляко, краставици и копър", description_en: "cold yogurt soup with cucumbers and dill", prices: { "350г": 2.99 }, image: taratorImg, tags: [] },
    { id: "soup-2", name_bg: "ПИЛЕШКА СУПА", name_en: "CHICKEN SOUP", description_bg: "домашна пилешка супа с юфка", description_en: "homemade chicken noodle soup", prices: { "350г": 3.49 }, image: pileshkaSupaIgn, tags: ["top"] },
    { id: "soup-3", name_bg: "КАРТОФЕНА КРЕМ СУПА", name_en: "CREAM OF POTATO SOUP", description_bg: "кремообразна картофена супа", description_en: "creamy potato soup", prices: { "350г": 3.49 }, image: kartofenaKremSupaIgn, tags: [] }
  ],

  // ==================== СОСОВЕ ====================
  sauces: [
    { id: "sauce-1", name_bg: "ЧЕСНОВ СОС", name_en: "GARLIC SAUCE", description_bg: "кремообразен чеснов сос", description_en: "creamy garlic sauce", prices: { "60г": 1.19 }, image: cesnovSosImg, tags: [] },
    { id: "sauce-2", name_bg: "ЧЕРВЕН СОС", name_en: "RED SAUCE", description_bg: "пикантен червен сос", description_en: "spicy red sauce", prices: { "60г": 1.19 }, image: chervenSosImg, tags: [] },
    { id: "sauce-3", name_bg: "БЯЛ СОС", name_en: "WHITE SAUCE", description_bg: "кремообразен бял сос", description_en: "creamy white sauce", prices: { "60г": 1.19 }, image: bialSosImg, tags: [] },
    { id: "sauce-4", name_bg: "ГОРЧИЦА", name_en: "MUSTARD", description_bg: "класическа горчица", description_en: "classic mustard", prices: { "60г": 1.19 }, image: gorchicaImg, tags: [] },
    { id: "sauce-5", name_bg: "СИЦИЛИАНСКИ СОС", name_en: "SICILIAN SAUCE", description_bg: "ароматен сицилиански сос", description_en: "aromatic Sicilian sauce", prices: { "60г": 1.19 }, image: sicilianaSosImg, tags: [] },
    { id: "sauce-6", name_bg: "ПИКАНТЕН СОС", name_en: "SPICY SAUCE", description_bg: "лютив пикантен сос", description_en: "hot spicy sauce", prices: { "60г": 1.19 }, image: pikantenSosImg, tags: ["spicy"] },
    { id: "sauce-7", name_bg: "БАРБЕКЮ СОС", name_en: "BARBECUE SAUCE", description_bg: "класически барбекю сос", description_en: "classic barbecue sauce", prices: { "60г": 1.49 }, image: barbekyuSosImg, tags: [] },
    { id: "sauce-8", name_bg: "СЛАДКО-КИСЕЛ СОС", name_en: "SWEET AND SOUR SAUCE", description_bg: "сладко-кисел сос", description_en: "sweet and sour sauce", prices: { "60г": 1.49 }, image: sladkoKiselSosImg, tags: [] },
  ],

  // ==================== ЗАПЕЧЕНИ КАРТОФИ ====================
  baked_potatoes: [
    { id: "potato-1", name_bg: "ЗАПЕЧЕНИ КАРТОФИ С БЕКОН", name_en: "BAKED POTATOES WITH BACON", description_bg: "запечени картофи с бекон, сметана, магданоз и кашкавал", description_en: "baked potatoes with bacon, cream, parsley and yellow cheese", prices: { "500г": 5.99 }, image: zapecheniSBekonImg, tags: [] },
    { id: "potato-2", name_bg: "ЗАПЕЧЕНИ КАРТОФИ С ПИЛЕ", name_en: "BAKED POTATOES WITH CHICKEN", description_bg: "запечени картофи с пушено пиле, сметана, копър и кашкавал", description_en: "baked potatoes with smoked chicken, cream, dill and yellow cheese", prices: { "500г": 5.99 }, image: zapecheniSPileImg, tags: [] },
    { id: "potato-3", name_bg: "ЗАПЕЧЕНИ КАРТОФИ С ШУНКА", name_en: "BAKED POTATOES WITH HAM", description_bg: "запечени картофи с шунка, сметана и кашкавал", description_en: "baked potatoes with ham, cream and yellow cheese", prices: { "500г": 5.99 }, image: zapecheniSShunkaImg, tags: [] },
    { id: "potato-4", name_bg: "ЗАПЕЧЕНИ КАРТОФИ СЪС СИРЕНЕ", name_en: "BAKED POTATOES WITH CHEESE", description_bg: "запечени картофи със сирене, домат, сметана, риган и кашкавал", description_en: "baked potatoes with cheese, tomato, cream, oregano and yellow cheese", prices: { "500г": 5.99 }, image: zapecheniSSireneImg, tags: [] }
  ],

  // ==================== ХЛЕБЧЕТА ====================
  breads: [
    { id: "bread-1", name_bg: "ЧЕСНОВО ХЛЕБЧЕ", name_en: "GARLIC BREAD", description_bg: "хлебче с чесново масло", description_en: "bread with garlic butter", prices: { "default": 2.19 }, image: chesnovoImg, tags: [] },
    { id: "bread-2", name_bg: "СУСАМЕНО ХЛЕБЧЕ", name_en: "SESAME BREAD", description_bg: "хлебче, поръсено със сусам", description_en: "bread topped with sesame seeds", prices: { "default": 2.19 }, image: susamenoImg, tags: [] },
    { id: "bread-3", name_bg: "СЕЛСКО ХЛЕБЧЕ", name_en: "COUNTRY BREAD", description_bg: "домашно селско хлебче", description_en: "homemade country bread", prices: { "default": 2.19 }, image: selskoHlebcheImg, tags: [] },
    { id: "bread-4", name_bg: "ХЛЕБЧЕ С КАШКАВАЛ", name_en: "CHEESE BREAD", description_bg: "хлебче с кашкавал", description_en: "bread with yellow cheese", prices: { "default": 2.99 }, image: kashkavalenoImg, tags: [] },
    { id: "bread-5", name_bg: "ИТАЛИАНСКО ХЛЕБЧЕ", name_en: "ITALIAN BREAD", description_bg: "хлебче с доматен сос, моцарела и песто", description_en: "bread with tomato sauce, mozzarella and pesto", prices: { "default": 3.99 }, image: italianskoHlebcheImg, tags: [] }
  ],

  // ==================== ПАСТА ====================
  pasta: [
    { id: "pasta-1", name_bg: "СПАГЕТИ ФОРМАДЖО", name_en: "SPAGHETTI FORMAGGIO", description_bg: "спагети със сметана, бяло сирене, топено сирене, рокфор и кашкавал", description_en: "spaghetti with cream, white cheese, melted cheese, roquefort and yellow cheese", prices: { "500г": 7.99 }, image: spagetiFormadjoImg, tags: [] },
    { id: "pasta-2", name_bg: "ПАСТА КАРБОНАРА", name_en: "PASTA CARBONARA", description_bg: "паста с бекон, сметана, яйце, черен пипер и кашкавал", description_en: "pasta with bacon, cream, egg, black pepper and yellow cheese", prices: { "500г": 7.99 }, image: pastaKarbonaraImg, tags: ["top"] },
    { id: "pasta-3", name_bg: "СПАГЕТИ МАТРИЧИНА", name_en: "SPAGHETTI MATRICIANA", description_bg: "спагети с доматен сос, гъби, бекон, магданоз и кашкавал", description_en: "spaghetti with tomato sauce, mushrooms, bacon, parsley and yellow cheese", prices: { "500г": 7.99 }, image: spagetiMatri4anaImg, tags: [] },
    { id: "pasta-4", name_bg: "ПАСТА КОРЛЕОНЕ", name_en: "PASTA CORLEONE", description_bg: "паста с доматен сос, гъби, шунка и кашкавал", description_en: "pasta with tomato sauce, mushrooms, ham and yellow cheese", prices: { "500г": 7.99 }, image: korleoneImg, tags: [] },
    { id: "pasta-5", name_bg: "ПАСТА БОЛОНЕЗЕ", name_en: "PASTA BOLOGNESE", description_bg: "паста с доматен сос, кайма, лук, моркови и кашкавал", description_en: "pasta with tomato sauce, minced meat, onion, carrots and yellow cheese", prices: { "500г": 7.99 }, image: pastaBolonezeImg, tags: ["top"] },
    { id: "pasta-6", name_bg: "ПАСТА ПОЛО", name_en: "PASTA POLO", description_bg: "паста със сметана, пилешка шунка, топено сирене и кашкавал", description_en: "pasta with cream, chicken ham, melted cheese and yellow cheese", prices: { "500г": 7.99 }, image: pastaPoloImg, tags: [] },
    { id: "pasta-7", name_bg: "ЛАЗАНЯ БОЛОНЕЗЕ", name_en: "LASAGNA BOLOGNESE", description_bg: "лазаня със сос Болонезе и кашкавал", description_en: "lasagna with Bolognese sauce and yellow cheese", prices: { "380г": 6.99 }, image: lazanyaBolonezeImg, tags: ["top"] }
  ],

  // ==================== МЕСНИ ЯСТИЯ ====================
  main_dishes: [
    { id: "main-1", name_bg: "ПИЛЕШКО ФИЛЕ С МАНАТАРКИ", name_en: "CHICKEN FILLET WITH TRUFFLES", description_bg: "пилешко филе с маслен сос от манатарки и печурки, гарнирано с пикантни картофи", description_en: "chicken fillet with truffle and mushroom butter sauce, served with spicy potatoes", prices: { "300г": 8.99 }, image: pileshkoFileSusSosImg, tags: ["top"] },
    { id: "main-2", name_bg: "ПИЛЕШКО КЪРИ СЪС ЗЕЛЕНЧУЦИ", name_en: "CHICKEN CURRY WITH VEGETABLES", description_bg: "пилешко къри с гриловани зеленчуци", description_en: "chicken curry with grilled vegetables", prices: { "350г": 8.49 }, image: pileshkoKarenceImg, tags: [] },
    { id: "main-3", name_bg: "ВИЕНСКИ ШНИЦЕЛ", name_en: "WIENER SCHNITZEL", description_bg: "свинско контра филе с пържени картофи", description_en: "pork tenderloin with french fries", prices: { "300г": 8.99 }, image: shnicelImg, tags: ["top"] },
    { id: "main-4", name_bg: "СВИНСКО БОН ФИЛЕ НА ХАПКИ", name_en: "PORK TENDERLOIN BITES", description_bg: "свинско бон филе, запържено в масло", description_en: "pork tenderloin bites sautéed in butter", prices: { "200г": 8.99 }, image: svinskoBonFileNaHapkiImg, tags: [] },
    { id: "main-5", name_bg: "СВИНСКО БОН ФИЛЕ С ГЪБИ", name_en: "PORK TENDERLOIN WITH MUSHROOMS", description_bg: "свинско бон филе с гъби и сос Демиглас, сервирано с бял ориз", description_en: "pork tenderloin with mushrooms and Demi-glace sauce, served with white rice", prices: { "300г": 9.99 }, image: svinskoBonFileSGabiImg, tags: [] },
    { id: "main-6", name_bg: "СВИНСКИ ВРАТ ЖУЛИЕН", name_en: "PORK NECK JULIENNE", description_bg: "свински врат с гъби, лук, сушени домати и бяло вино", description_en: "pork neck with mushrooms, onion, sun-dried tomatoes and white wine", prices: { "300г": 8.49 }, image: svinskiVratniImg, tags: [] },
    { id: "main-7", name_bg: "КРЕХКО ТЕЛЕШКО", name_en: "TENDER VEAL", description_bg: "крехко телешко с бейби моркови и гъби", description_en: "tender veal with baby carrots and mushrooms", prices: { "300г": 10.99 }, image: krehkoTeleshkoImg, tags: ["top"] }
  ],

  // ==================== РИБА И СКАРА ====================
  fish_grill: [
    { id: "fish-1", name_bg: "КОМБИНИРАНО ПЛАТО ОТ СКАРА", name_en: "MIXED GRILL PLATE", description_bg: "плато с 5 различни вида меса от скара", description_en: "plate with 5 different types of grilled meat", prices: { "1кг": 22.99 }, image: kombiniranoPlatoImg, tags: ["top"] },
    { id: "fish-2", name_bg: "МЕНЮ ЗА ДВАМА", name_en: "MENU FOR TWO", description_bg: "пилешка пържола, кюфте, кебапче, карпаче и пържени картофи", description_en: "chicken steak, meatball, kebabche, carpaccio and french fries", prices: { "550г": 12.49 }, image: menuZaDvamaImg, tags: ["top"] },
    { id: "fish-3", name_bg: "СВИНСКИ ДЖОЛАН", name_en: "PORK HOCK", description_bg: "печен свински джолан с картофи соте", description_en: "roasted pork hock with sautéed potatoes", prices: { "600г": 10.99 }, image: djolanImg, tags: [] },
    { id: "fish-4", name_bg: "СВИНСКИ МАРИНОВАНИ РЕБРА", name_en: "MARINATED PORK RIBS", description_bg: "свински ребра с барбекю сос", description_en: "pork ribs with barbecue sauce", prices: { "350г": 8.99 }, image: svinskiRebraImg, tags: ["top"] },
    { id: "fish-5", name_bg: "ТЕЛЕШКИ КЮФТЕНЦА", name_en: "VEAL MEATBALLS", description_bg: "телешки кюфтенца с пържени картофи и лютеница", description_en: "veal meatballs with french fries and lutenitsa", prices: { "300г": 9.99 }, image: teleshkiKiuftencaImg, tags: [] },
    { id: "fish-6", name_bg: "АДАНА КЕБАП", name_en: "ADANA KEBAP", description_bg: "телешко-агнешки шишчета с ориз и сотирани зеленчуци", description_en: "veal-lamb skewers with rice and sautéed vegetables", prices: { "350г": 10.99 }, image: adanaKebapImg, tags: [] },
    { id: "fish-7", name_bg: "ТЕЛЕШКИ МИНИ КЕБАПЧЕТА", name_en: "MINI VEAL KEBAPCHETA", description_bg: "телешки кебапчета с пържени картофи", description_en: "veal kebapcheta with french fries", prices: { "350г": 9.99 }, image: miniTeleshkiKebapchetaImg, tags: [] },
    { id: "fish-8", name_bg: "БЯЛА РИБА ПАНЕ", name_en: "WHITE FISH BREADED", description_bg: "панирана бяла риба с картофи соте", description_en: "breaded white fish with sautéed potatoes", prices: { "300г": 9.99 }, image: bqlaRibaPaneImg, tags: ["top"] },
    { id: "fish-9", name_bg: "ПЪСТЪРВА НА СКАРА", name_en: "GRILLED TROUT", description_bg: "пъстърва на скара с картофи соте", description_en: "grilled trout with sautéed potatoes", prices: { "400г": 9.99 }, image: pastarvaImg, tags: ["top"] },
    { id: "fish-10", name_bg: "ПЪРЖЕНИ КАЛМАРИ", name_en: "FRIED CALAMARI", description_bg: "хрупкави пържени калмари", description_en: "crispy fried calamari", prices: { "200г": 9.99 }, image: paniraniKalmariImg, tags: [] },
    { id: "fish-11", name_bg: "ЛАВРАК НА СКАРА", name_en: "GRILLED SEA BASS", description_bg: "лаврак на скара с картофи соте", description_en: "grilled sea bass with sautéed potatoes", prices: { "300г": 10.99 }, image: lavrakImg, tags: [] },
    { id: "fish-12", name_bg: "ПИЛЕШКА МЕШАНА СКАРА", name_en: "MIXED CHICKEN GRILL", description_bg: "пилешка пържола, шишче, крилца и дробчета", description_en: "chicken steak, skewer, wings and giblets", prices: { "450г": 12.49 }, image: pileshkaMeshanaSkaraImg, tags: [] },
    { id: "fish-13", name_bg: "СВИНСКА МЕШАНА СКАРА", name_en: "MIXED PORK GRILL", description_bg: "свинска пържола, шишче, кюфте и кебапче", description_en: "pork steak, skewer, meatball and kebabche", prices: { "450г": 12.49 }, image: svinskaMeshanaSkaraImg, tags: [] },
    { id: "fish-14", name_bg: "ПИЛЕШКА ПЪРЖОЛА ОТ БУТЧЕ", name_en: "CHICKEN THIGH STEAK", description_bg: "пилешка пържола от бутче на скара", description_en: "grilled chicken thigh steak", prices: { "200г": 6.99 }, image: pileshkaPurjolaOtButcheImg, tags: [] },
    { id: "fish-15", name_bg: "ПИЛЕШКА ПЪРЖОЛА ОТ ФИЛЕ", name_en: "CHICKEN FILLET STEAK", description_bg: "пилешка пържола от филе на скара", description_en: "grilled chicken fillet steak", prices: { "200г": 6.99 }, image: pileshkaPurjolaOtFileImg, tags: [] },
    { id: "fish-16", name_bg: "СВИНСКА ВРАТНА ПЪРЖОЛА", name_en: "PORK NECK STEAK", description_bg: "свинска вратна пържола на скара", description_en: "grilled pork neck steak", prices: { "200г": 6.99 }, image: svinskaVratnaPurjolaImg, tags: [] },
    { id: "fish-17", name_bg: "КЕБАПЧЕ", name_en: "KEBAPCHE", description_bg: "", description_en: "", prices: { "80г": 1.49 }, image: kebapcheImg, tags: [] },
    { id: "fish-18", name_bg: "КЮФТЕ", name_en: "MEATBALL", description_bg: "", description_en: "", prices: { "80г": 1.49 }, image: kiuftemImg, tags: [] },
    { id: "fish-19", name_bg: "ПИЛЕШКО ШИШЧЕ", name_en: "CHICKEN SKEWER", description_bg: "пилешко шишче на скара", description_en: "grilled chicken skewer", prices: { "100г": 3.49 }, image: pileshkoShishcheImg, tags: [] },
    { id: "fish-20", name_bg: "СВИНСКО ШИШЧЕ", name_en: "PORK SKEWER", description_bg: "свинско шишче на скара", description_en: "grilled pork skewer", prices: { "100г": 3.49 }, image: svinskoShishcheImg, tags: [] },
    { id: "fish-21", name_bg: "КОМБИНИРАН САЧ", name_en: "MIXED SACH", description_bg: "свински врат, пилешко филе, зеленчуци и кашкавал, печени на сач", description_en: "pork neck, chicken fillet, vegetables and yellow cheese baked on a sach", prices: { "650г": 12.99 }, image: kombiniranSachImg, tags: ["top"] }
  ],

  // ==================== ДЕСЕРТИ ====================
  desserts: [
    { id: "dessert-1", name_bg: "ЧИЙЗКЕЙК", name_en: "CHEESECAKE", description_bg: "класически чийзкейк с бисквитена основа", description_en: "classic cheesecake with biscuit base", prices: { "200г": 3.99 }, image: chiizKeikImg, tags: ["top"] },
    { id: "dessert-2", name_bg: "КРЕМ КАРАМЕЛ", name_en: "CRÈME CARAMEL", description_bg: "кремообразен крем карамел", description_en: "creamy crème caramel", prices: { "150г": 2.99 }, image: kremKaramelImg, tags: [] },
    { id: "dessert-3", name_bg: "МЛЕЧНА НАСЛАДА", name_en: "MILKY DELIGHT", description_bg: "кремообразен млечен десерт", description_en: "creamy milk dessert", prices: { "200г": 3.99 }, image: mle4naNasladaImg, tags: [] },
    { id: "dessert-4", name_bg: "ПЛОДОВА САЛАТА", name_en: "FRUIT SALAD", description_bg: "салата от пресни сезонни плодове", description_en: "fresh seasonal fruit salad", prices: { "200г": 3.99 }, image: plodovaSalataImg, tags: [] },
    { id: "dessert-5", name_bg: "МЕЛБА", name_en: "MELBA", description_bg: "десерт Мелба със сладолед и пресни плодове", description_en: "Melba dessert with ice cream and fresh fruits", prices: { "250г": 4.49 }, image: melbaImg, tags: [] },
    { id: "dessert-6", name_bg: "СЛАДОЛЕД", name_en: "ICE CREAM", description_bg: "сладолед по избор - ванилия, шоколад или ягода", description_en: "ice cream of choice - vanilla, chocolate or strawberry", prices: { "180г": 3.99 }, image: sladoledImg, tags: [] },
    { id: "dessert-7", name_bg: "ПАЛАЧИНКИ", name_en: "PANCAKES", description_bg: "две палачинки с шоколад, мед или сладко", description_en: "two pancakes with chocolate, honey or jam", prices: { "2бр": 4.99 }, image: palachinkaImg, tags: [] }
  ],

  // ==================== ДОБАВКИ ====================
  extras: [
    { id: "extra-1", name_bg: "ЯЙЦЕ", name_en: "EGG", description_bg: "допълнително яйце", description_en: "extra egg", prices: { "50г": 0.80 }, image: alergeniImg, tags: [] },
    { id: "extra-2", name_bg: "БЯЛО СИРЕНЕ", name_en: "WHITE CHEESE", description_bg: "допълнително бяло сирене", description_en: "extra white cheese", prices: { "50г": 1.19 }, image: alergeniImg, tags: [] },
    { id: "extra-3", name_bg: "РОКФОР", name_en: "ROQUEFORT", description_bg: "допълнително сирене рокфор", description_en: "extra roquefort cheese", prices: { "50г": 1.99 }, image: alergeniImg, tags: [] },
    { id: "extra-4", name_bg: "ТОПЕНО СИРЕНЕ", name_en: "MELTED CHEESE", description_bg: "допълнително топено сирене", description_en: "extra melted cheese", prices: { "50г": 1.49 }, image: alergeniImg, tags: [] },
    { id: "extra-5", name_bg: "КАШКАВАЛ", name_en: "YELLOW CHEESE", description_bg: "допълнителен кашкавал", description_en: "extra yellow cheese", prices: { "50г": 1.49 }, image: alergeniImg, tags: [] },
    { id: "extra-6", name_bg: "ЛУКАНКА", name_en: "SAUSAGE", description_bg: "допълнителна луканка", description_en: "extra sausage", prices: { "50г": 1.99 }, image: alergeniImg, tags: [] },
    { id: "extra-7", name_bg: "КАЛМАРИ", name_en: "CALAMARI", description_bg: "допълнителни калмари", description_en: "extra calamari", prices: { "50г": 2.49 }, image: alergeniImg, tags: [] },
    { id: "extra-8", name_bg: "СКАРДИ", name_en: "SCAD", description_bg: "допълнителни скарди", description_en: "extra scad", prices: { "50г": 2.99 }, image: alergeniImg, tags: [] },
    { id: "extra-9", name_bg: "РИБА ТОН", name_en: "TUNA", description_bg: "допълнителна риба тон", description_en: "extra tuna", prices: { "50г": 1.99 }, image: alergeniImg, tags: [] },
    { id: "extra-10", name_bg: "ПУШЕНО ПИЛЕ", name_en: "SMOKED CHICKEN", description_bg: "допълнително пушено пиле", description_en: "extra smoked chicken", prices: { "50г": 1.49 }, image: alergeniImg, tags: [] },
    { id: "extra-11", name_bg: "БЕКОН", name_en: "BACON", description_bg: "допълнителен бекон", description_en: "extra bacon", prices: { "50г": 1.49 }, image: alergeniImg, tags: [] },
    { id: "extra-12", name_bg: "ШУНКА", name_en: "HAM", description_bg: "допълнителна шунка", description_en: "extra ham", prices: { "50г": 1.49 }, image: alergeniImg, tags: [] },
    { id: "extra-13", name_bg: "ЛЮТИ ЧУШКИ", name_en: "HOT PEPPERS", description_bg: "допълнителни люти чушки", description_en: "extra hot peppers", prices: { "3бр": 1.49 }, image: alergeniImg, tags: ["spicy"] },
    { id: "extra-14", name_bg: "ЛЮТЕНИЦА", name_en: "LUTENITSA", description_bg: "допълнителна лютеница", description_en: "extra lutenitsa", prices: { "100г": 1.49 }, image: alergeniImg, tags: [] },
    { id: "extra-15", name_bg: "ЗЕЛЕНЧУЦИ", name_en: "VEGETABLES", description_bg: "допълнителни зеленчуци", description_en: "extra vegetables", prices: { "50г": 0.99 }, image: alergeniImg, tags: [] },
    { id: "extra-16", name_bg: "ФИЛИЙКА ХЛЯБ", name_en: "BREAD SLICE", description_bg: "една филийка хляб", description_en: "one slice of bread", prices: { "1бр": 0.30 }, image: alergeniImg, tags: [] }
  ],

  // ==================== БЕЗАЛКОХОЛНИ НАПИТКИ ====================
  soft_drinks: [
    { id: "drink-1", name_bg: "ПРЯСНО ИЗЦЕДЕН ПОРТОКАЛ", name_en: "FRESH ORANGE JUICE", description_bg: "прясно изцеден портокалов сок", description_en: "freshly squeezed orange juice", prices: { "200мл": 3.99 }, image: freshPortokalImg, tags: [] },
    { id: "drink-2", name_bg: "ДОМАШНА ЛИМОНАДА", name_en: "HOMEMADE LEMONADE", description_bg: "домашна лимонада - малина, мента, ягода или класическа", description_en: "homemade lemonade - raspberry, mint, strawberry or classic", prices: { "500мл": 3.49, "1л": 5.99 }, image: domashnaLimonadaImg, tags: ["top"] },
    { id: "drink-3", name_bg: "АЙРЯН", name_en: "AIRYAN", description_bg: "освежаващ айрян", description_en: "refreshing airyan", prices: { "330мл": 1.99, "1л": 4.99 }, image: AiryanImg, imageContain: true, tags: [] },
    { id: "drink-4", name_bg: "КОКА-КОЛА", name_en: "COCA-COLA", description_bg: "Кока-Кола", description_en: "Coca-Cola", prices: { "250мл": 1.99 }, image: cocaColaImg, tags: [] },
    { id: "drink-5", name_bg: "КОКА-КОЛА ЗЕРО", name_en: "COCA-COLA ZERO", description_bg: "Кока-Кола без захар", description_en: "Coca-Cola Zero Sugar", prices: { "250мл": 1.99 }, image: cocaColaZeroImg, tags: [] },
    { id: "drink-7", name_bg: "ФАНТА", name_en: "FANTA", description_bg: "Фанта", description_en: "Fanta", prices: { "250мл": 1.99 }, image: fantaImg, tags: [] },
    { id: "drink-8", name_bg: "СПРАЙТ", name_en: "SPRITE", description_bg: "Спрайт", description_en: "Sprite", prices: { "250мл": 1.99 }, image: spriteImg, tags: [] },
    { id: "drink-9", name_bg: "ШВЕПС", name_en: "SCHWEPPES", description_bg: "Швепс тоник или горчив", description_en: "Schweppes tonic or bitter", prices: { "250мл": 1.99 }, image: schweppesImg, tags: [] },
    { id: "drink-10", name_bg: "ШВЕПС КЛУБ СОДА", name_en: "SCHWEPPES CLUB SODA", description_bg: "Швепс клуб сода", description_en: "Schweppes club soda", prices: { "250мл": 1.49 }, image: schweppesSodaImg, tags: [] },
    { id: "drink-11", name_bg: "КАПИ СОК", name_en: "CAPPY JUICE", description_bg: "Капи плодов сок", description_en: "Cappy fruit juice", prices: { "250мл": 1.99 }, image: cappyImg, tags: [] },
    { id: "drink-12", name_bg: "КАПИ ЛИМОНАДА", name_en: "CAPPY LEMONADE", description_bg: "Капи лимонада", description_en: "Cappy lemonade", prices: { "250мл": 1.99 }, image: cappyLimonadaImg, tags: [] },
    { id: "drink-13", name_bg: "FUZE TEA", name_en: "FUZE TEA", description_bg: "Fuze Tea", description_en: "Fuze Tea", prices: { "250мл": 1.99 }, image: fuzeTeaImg, tags: [] },
    { id: "drink-14", name_bg: "МИНЕРАЛНА ВОДА БАНКЯ", name_en: "BANKYA WATER", description_bg: "минерална вода Банкия", description_en: "Bankya mineral water", prices: { "330мл": 1.49, "1л": 2.49 }, image: bankyaWaterImg, tags: [] }
  ],

  // ==================== ТОПЛИ НАПИТКИ ====================
  hot_drinks: [
    { id: "hot-1", name_bg: "ЕСПРЕСО ЛАВАЦА", name_en: "LAVAZZA ESPRESSO", description_bg: "класическо еспресо Лаваца", description_en: "classic Lavazza espresso", prices: { "50мл": 1.49 }, image: lavazzaImg, tags: [] },
    { id: "hot-2", name_bg: "КАПУЧИНО", name_en: "CAPPUCCINO", description_bg: "капучино с мляко", description_en: "cappuccino with milk", prices: { "150мл": 2.49 }, image: cappuccinoImg, tags: [] },
    { id: "hot-3", name_bg: "ВИЕНСКО КАФЕ", name_en: "VIENNA COFFEE", description_bg: "виенско кафе със сметана", description_en: "Vienna coffee with cream", prices: { "150мл": 2.49 }, image: viennaCoffeeImg, tags: [] },
    { id: "hot-4", name_bg: "СТУДЕНО КАФЕ", name_en: "ICED COFFEE", description_bg: "студено кафе", description_en: "iced coffee", prices: { "150мл": 2.49 }, image: icedCoffeeImg, tags: [] },
    { id: "hot-5", name_bg: "МЛЯКО С НЕСКАФЕ", name_en: "MILK WITH NESCAFE", description_bg: "горещо мляко с Нескафе", description_en: "hot milk with Nescafe", prices: { "200мл": 2.49 }, image: milkWithNescafeImg, tags: [] },
    { id: "hot-6", name_bg: "ЧАЙ", name_en: "TEA", description_bg: "билков, черен, зелен или плодов чай", description_en: "herbal, black, green or fruit tea", prices: { "150мл": 1.49 }, image: teaImg, tags: [] },
    { id: "hot-7", name_bg: "МЕД", name_en: "HONEY", description_bg: "добавка мед", description_en: "honey addition", prices: { "15мл": 0.49 }, image: honeyImg, tags: [] },
    { id: "hot-8", name_bg: "СМЕТАНА", name_en: "CREAM", description_bg: "добавка сметана - течна или суха", description_en: "cream addition - liquid or dry", prices: { "7.5мл": 0.49 }, image: creamImg, imageContain: true, tags: [] }
  ],

  // ==================== АЛКОХОЛНИ НАПИТКИ ====================
  spirits: [
    { id: "spirit-1", name_bg: "ПЕЩЕРСКА ОТЛЕЖАЛА РАКИЯ", name_en: "PESHTERA AGED RAKIA", description_bg: "отлежала гроздова ракия", description_en: "aged grape rakia", prices: { "50мл": 1.99 }, image: peshteraRakiaImg, tags: [] },
    { id: "spirit-2", name_bg: "ТРОЯНСКА СЛИВОВА РАКИЯ", name_en: "TROYANSKA PLUM RAKIA", description_bg: "отлежала сливова ракия", description_en: "aged plum rakia", prices: { "50мл": 2.29 }, image: troyanskaRakiaImg, tags: [] },
    { id: "spirit-3", name_bg: "СТРАЛДЖАНСКА МУСКАТОВА", name_en: "STRALDZHANSKA MUSCAT", description_bg: "мускатова ракия", description_en: "muscat rakia", prices: { "50мл": 2.99 }, image: straldzhanskaRakiaImg, tags: [] },
    { id: "spirit-4", name_bg: "БУРГАСКА МУСКАТОВА", name_en: "BURGASKA MUSCAT", description_bg: "мускатова ракия Бургас", description_en: "Burgas muscat rakia", prices: { "50мл": 2.49 }, image: burgaskaRakiaImg, tags: [] },
    { id: "spirit-5", name_bg: "БУРГАС 63", name_en: "BURGAS 63", description_bg: "ракия Бургас 63", description_en: "Burgas 63 rakia", prices: { "50мл": 2.99 }, image: burgas63Img, tags: [] },
    { id: "spirit-6", name_bg: "АБСОЛЮТ ВОДКА", name_en: "ABSOLUT VODKA", description_bg: "водка Абсолют", description_en: "Absolut vodka", prices: { "50мл": 2.99 }, image: absolutVodkaImg, tags: [] },
    { id: "spirit-7", name_bg: "ФИНЛАНДИЯ ВОДКА", name_en: "FINLANDIA VODKA", description_bg: "водка Финландия", description_en: "Finlandia vodka", prices: { "50мл": 2.99 }, image: finlandiaVodkaImg, tags: [] },
    { id: "spirit-8", name_bg: "БЪЛГАРСКА ВОДКА", name_en: "BULGARIAN VODKA", description_bg: "българска водка", description_en: "Bulgarian vodka", prices: { "50мл": 1.99 }, image: bulgarianVodkaImg, tags: [] },
    { id: "spirit-9", name_bg: "БИЙФИЙТЪР ДЖИН", name_en: "BEEFEATER GIN", description_bg: "Beefeater джин", description_en: "Beefeater gin", prices: { "50мл": 2.99 }, image: beefeaterGinImg, tags: [] },
    { id: "spirit-10", name_bg: "БЪЛГАРСКИ ДЖИН", name_en: "BULGARIAN GIN", description_bg: "български джин", description_en: "Bulgarian gin", prices: { "50мл": 1.99 }, image: bulgarianGinImg, tags: [] },
    { id: "spirit-11", name_bg: "ДЖОНИ УОКЪР УИСКИ", name_en: "JOHNNIE WALKER WHISKY", description_bg: "Johnnie Walker Red Label", description_en: "Johnnie Walker Red Label", prices: { "50мл": 2.99 }, image: johnnieWalkerImg, tags: [] },
    { id: "spirit-12", name_bg: "ДЖОНИ УОКЪР 12 ГОДИШНО", name_en: "JOHNNIE WALKER 12 YEAR", description_bg: "Johnnie Walker Black Label 12 години", description_en: "Johnnie Walker Black Label 12 years", prices: { "50мл": 5.99 }, image: johnnieWalker12Img, tags: [] },
    { id: "spirit-13", name_bg: "ТЮЛАМОР ДЮ УИСКИ", name_en: "TULLAMORE DEW WHISKY", description_bg: "Tullamore D.E.W. уиски", description_en: "Tullamore D.E.W. whisky", prices: { "50мл": 3.49 }, image: tullamoreDewImg, tags: [] },
    { id: "spirit-14", name_bg: "ДЖЕЙМИСЪН УИСКИ", name_en: "JAMESON WHISKY", description_bg: "Jameson ирландско уиски", description_en: "Jameson Irish whiskey", prices: { "50мл": 3.49 }, image: jamesonImg, tags: [] },
    { id: "spirit-15", name_bg: "ДЖАК ДАНИЕЛС УИСКИ", name_en: "JACK DANIEL'S WHISKY", description_bg: "Jack Daniel's Tennessee уиски", description_en: "Jack Daniel's Tennessee whiskey", prices: { "50мл": 3.99 }, image: jackDanielsImg, tags: [] },
    { id: "spirit-16", name_bg: "МАСТИКА ПЕЩЕРА", name_en: "PESHTERA MASTIKA", description_bg: "мастика от Пещера", description_en: "Peshtera mastika", prices: { "50мл": 1.99 }, image: peshteraMastikaImg, tags: [] },
    { id: "spirit-17", name_bg: "МЕНТА ПЕЩЕРА", name_en: "PESHTERA MENTHA", description_bg: "ментова ракия", description_en: "mentha rakia", prices: { "50мл": 1.99 }, image: peshteraMenthaImg, tags: [] },
    { id: "spirit-18", name_bg: "УЗО ПЛОМАРИ", name_en: "OUZO PLOMARI", description_bg: "гръцко узо Пломари", description_en: "Greek ouzo Plomari", prices: { "50мл": 2.99 }, image: ouzoPlomariImg, tags: [] },
    { id: "spirit-19", name_bg: "УЗО БУТИЛКА", name_en: "OUZO BOTTLE", description_bg: "узо в бутилка", description_en: "ouzo bottle", prices: { "200мл": 8.99 }, image: ouzoBottleImg, tags: [] },
    { id: "spirit-20", name_bg: "БЪЛГАРСКИ КОНЯК", name_en: "BULGARIAN COGNAC", description_bg: "български коняк", description_en: "Bulgarian cognac", prices: { "50мл": 2.49 }, image: bulgarianCognacImg, tags: [] },
    { id: "spirit-21", name_bg: "СЛИВЕНСКА ПЕРЛА", name_en: "SLIVEN PEARL", description_bg: "ракия Сливенска перла", description_en: "Sliven pearl rakia", prices: { "50мл": 2.99 }, image: slivenskaperlaImg, tags: [] },
  ],

  // ==================== БИРА ====================
  beer: [
    { id: "beer-1", name_bg: "СТАРОПРАМЕН СВЕТЛА", name_en: "STAROPRAMEN LIGHT", description_bg: "Старопрамен светла бира наливна", description_en: "Staropramen light draft beer", prices: { "330мл": 2.99, "500мл": 3.49, "1л": 5.99 }, image: staropramenDraftImg, tags: [] },
    { id: "beer-2", name_bg: "СТАРОПРАМЕН ТЪМНА", name_en: "STAROPRAMEN DARK", description_bg: "Старопрамен тъмна бира наливна", description_en: "Staropramen dark draft beer", prices: { "330мл": 2.99, "500мл": 3.49, "1л": 5.99 }, image: staropramenDarkDraftImg, tags: [] },
    { id: "beer-3", name_bg: "СТЕЛА АРТОА", name_en: "STELLA ARTOIS", description_bg: "Стела Артоа бира наливна", description_en: "Stella Artois draft beer", prices: { "330мл": 2.99, "500мл": 3.49, "1л": 5.99 }, image: stellaArtoisDraftImg, tags: [] },
    { id: "beer-4", name_bg: "ЧЕШКА БИРА", name_en: "CZECH BEER", description_bg: "чешка бира наливна", description_en: "Czech draft beer", prices: { "330мл": 2.99, "500мл": 3.99, "1л": 6.99 }, image: stellaArtoisDraftImg, tags: [] },
    { id: "beer-5", name_bg: "КАМЕНИЦА", name_en: "KAMENITZA", description_bg: "Каменица бира", description_en: "Kamenitza beer", prices: { "500мл": 2.49 }, image: kamenitzaImg, tags: [] },
    { id: "beer-6", name_bg: "БУРГАСКО", name_en: "BURGASKO", description_bg: "Бургаско бира", description_en: "Burgasko beer", prices: { "500мл": 2.49 }, image: burgaskoImg, tags: [] },
    { id: "beer-7", name_bg: "БЕКС БЕЗАЛКОХОЛНА", name_en: "BECKS NON-ALCOHOLIC", description_bg: "Becks безалкохолна бира", description_en: "Becks non-alcoholic beer", prices: { "330мл": 2.99 }, image: becksNonAlcoholicImg, tags: [] },
    { id: "beer-8", name_bg: "СТАРОПРАМЕН БУТИЛКА", name_en: "STAROPRAMEN BOTTLE", description_bg: "Старопрамен бира в бутилка", description_en: "Staropramen bottled beer", prices: { "500мл": 2.99 }, image: staropramenImg, tags: [] },
    { id: "beer-9", name_bg: "СТАРОПРАМЕН ТЪМНА БУТИЛКА", name_en: "STAROPRAMEN DARK BOTTLE", description_bg: "Старопрамен тъмна бира в бутилка", description_en: "Staropramen dark bottled beer", prices: { "500мл": 2.99 }, image: staropramenDarkImg, tags: [] },
    { id: "beer-10", name_bg: "СТЕЛА АРТОА БУТИЛКА", name_en: "STELLA ARTOIS BOTTLE", description_bg: "Стела Артоа бира в бутилка", description_en: "Stella Artois bottled beer", prices: { "500мл": 3.49 }, image: stellaArtoisImg, tags: [] },
    { id: "beer-11", name_bg: "ЛЕФЕ", name_en: "LEFFE", description_bg: "Leffe светла или тъмна бира", description_en: "Leffe blonde or brown beer", prices: { "330мл": 3.99 }, image: leffeImg, tags: [] },
    { id: "beer-12", name_bg: "ХАЙНЕКЕН", name_en: "HEINEKEN", description_bg: "Heineken бира", description_en: "Heineken beer", prices: { "330мл": 3.49 }, image: heinekenImg, tags: [] },
    { id: "beer-13", name_bg: "ЧЕШКА БИРА БУТИЛКА", name_en: "CZECH BEER BOTTLE", description_bg: "чешка бира - Pilsner Urquell, Kozel и други", description_en: "Czech beer - Pilsner Urquell, Kozel and others", prices: { "500мл": 3.99 }, image: czechBeerImg, tags: [] },
  ],

  // ==================== ВИНА ====================
  wines: [
    { id: "wine-1", name_bg: "ПАПИЙОН - ТАМЯНКА", name_en: "PAPILLON - INCENSE", description_bg: "бяло вино Тамянка", description_en: "white wine Incense", prices: { "750мл": 17.99 }, image: whitepapillonImg, tags: [] },
    { id: "wine-2", name_bg: "ЛОГОДАЖ - СОВИНЬОН БЛАН", name_en: "LOGODAGE - SAUVIGNON BLANC", description_bg: "бяло вино Совиньон Блан", description_en: "white wine Sauvignon Blanc", prices: { "750мл": 17.99 }, image: whitelogodageblancImg, tags: [] },
    { id: "wine-3", name_bg: "ЛОГОДАЖ - ПИНО ГРИДЖО", name_en: "LOGODAGE - PINOT GRIGIO", description_bg: "бяло вино Пино Гриджо", description_en: "white wine Pinot Grigio", prices: { "750мл": 17.99 }, image: whitelogodagegrigioImg, tags: [] },
    { id: "wine-4", name_bg: "ПАПИЙОН - КАБЕРНЕ", name_en: "PAPILLON - CABERNET", description_bg: "червено вино Каберне", description_en: "red wine Cabernet", prices: { "750мл": 17.99 }, image: redpapillonImg, tags: ["top"] },
    { id: "wine-5", name_bg: "ЛОГОДАЖ - ШИРАЗ И КАБЕРНЕ", name_en: "LOGODAGE - SHIRAZ AND CABERNET", description_bg: "червено вино Шираз и Каберне", description_en: "red wine Shiraz and Cabernet", prices: { "750мл": 17.99 }, image: redlogodagecabernetImg, tags: ["top"] },
    { id: "wine-6", name_bg: "ЛОГОДАЖ - МЕЛНИК 55", name_en: "LOGODAGE - MELNIK 55", description_bg: "червено вино Мелник 55", description_en: "red wine Melnik 55", prices: { "750мл": 17.99 }, image: redlogodage55Img, tags: ["top"] },
    { id: "wine-7", name_bg: "ПАПИЙОН - РОЗЕ", name_en: "PAPILLON - ROSÉ", description_bg: "розе вино", description_en: "rosé wine", prices: { "750мл": 17.99 }, image: rosepapillonImg, tags: ["top"] },
    { id: "wine-8", name_bg: "СОВИНЬОН БЛАН И ШАРДОНЕ", name_en: "SAUVIGNON BLANC AND CHARDONNAY", description_bg: "наливно бяло вино", description_en: "draft white wine", prices: { "500мл": 6.99, "1л": 10.99 }, image: whitedraftSAUVIGNONBLANCImg, tags: ["top"] },
    { id: "wine-9", name_bg: "КАБЕРНЕ И МЕРЛО", name_en: "CABERNET AND MERLOT", description_bg: "наливно червено вино", description_en: "draft red wine", prices: { "200мл": 3.99, "500мл": 6.99, "1л": 10.99 }, image: reddraftCABERNETANDMERLOTImg, tags: ["top"] }
  ]
};

export const menuData = categorizeMenuData(uncategorizedMenuData);

// ==================== КАТЕГОРИИ ====================
export const categories = [
  { id: "pizza", name_bg: "Пици", name_en: "Pizza", icon: "pizza" },
  { id: "kids_menu", name_bg: "Детско меню", name_en: "Kids Menu", icon: "baby" },
  { id: "salads", name_bg: "Салати", name_en: "Salads", icon: "salad" },
  { id: "appetizers", name_bg: "Топли предястия", name_en: "Appetizers", icon: "flame" },
  { id: "alaminute", name_bg: "Аламинути", name_en: "A la Minute", icon: "clock" },
  { id: "soups", name_bg: "Супи", name_en: "Soups", icon: "utensils" },
  { id: "sauces", name_bg: "Сосове", name_en: "Sauces", icon: "droplet" },
  { id: "baked_potatoes", name_bg: "Запечени картофи", name_en: "Baked Potatoes", icon: "flame" },
  { id: "breads", name_bg: "Хлебчета", name_en: "Breads", icon: "croissant" },
  { id: "pasta", name_bg: "Паста", name_en: "Pasta", icon: "utensils" },
  { id: "main_dishes", name_bg: "Месни ястия", name_en: "Main Dishes", icon: "utensils" },
  { id: "fish_grill", name_bg: "Риба и скара", name_en: "Fish & Grill", icon: "fish" },
  { id: "desserts", name_bg: "Десерти", name_en: "Desserts", icon: "cake" },
  { id: "extras", name_bg: "Добавки", name_en: "Extras", icon: "plus" },
  { id: "soft_drinks", name_bg: "Безалкохолни", name_en: "Soft Drinks", icon: "glass" },
  { id: "hot_drinks", name_bg: "Топли напитки", name_en: "Hot Drinks", icon: "coffee" },
  { id: "spirits", name_bg: "Алкохолни напитки", name_en: "Spirits", icon: "wine" },
  { id: "beer", name_bg: "Бира", name_en: "Beer", icon: "beer" },
  { id: "wines", name_bg: "Вина", name_en: "Wines", icon: "wine" },
];

// ==================== АЛЕРГЕНИ ====================
export const allergens = {
  description_bg: "Алергени: 1. Глутен, 2. Ракообразни, 3. Яйца, 4. Риба, 5. Фъстъци, 6. Соя, 7. Мляко, 8. Ядки, 9. Целина, 10. Синап, 11. Сусам, 12. Лупина, 13. Мекотели, 14. Серен диоксид/сулфити",
  description_en: "Allergens: 1. Gluten, 2. Crustaceans, 3. Eggs, 4. Fish, 5. Peanuts, 6. Soy, 7. Milk, 8. Nuts, 9. Celery, 10. Mustard, 11. Sesame, 12. Lupin, 13. Molluscs, 14. Sulphur Dioxide/Sulphites"
};

// ==================== ПРЕВОДИ ====================
export const translations = {
  en: {
    hero_title: "Taste makes sense.",
    hero_subtitle: "Immerse yourself in authentic flavors created with care and passion.",
    view_menu: "View Menu",
    search_placeholder: "Search menu...",
    filter_all: "All",
    filter_vegan: "Vegan",
    filter_vegetarian: "Vegetarian",
    filter_top: "Popular",
    add_to_cart: "Add to Cart",
    cart: "Cart",
    your_order: "Your Order",
    empty_cart: "Your cart is empty",
    total: "Total",
    close: "Close",
    size: "Size",
    sizes: "Sizes",
    kids_menu_title: "Kids Menu",
    kids_menu_short: "Kids pizza, Cappy juice, pancake and a gift",
    included_in_kids_menu: "Included in the kids menu",
    food_safety_notice: "Dishes are fit for consumption for up to 5 hours after serving and are cleared away afterwards.",
    quantity: "Quantity",
    remove: "Remove",
    currency: "BGN",
    items: "items",
    nav_home: "Home",
    nav_menu: "Menu",
    footer_text: "Quality Italian food since 1995",
    follow_us: "Follow Us",
    language: "en"
  },
  bg: {
    hero_title: "Вкусът има смисъл.",
    hero_subtitle: "Потопете се в автентични вкусове, създадени с внимание и страст.",
    view_menu: "Вижте Менюто",
    search_placeholder: "Търсене в менюто...",
    filter_all: "Всички",
    filter_vegan: "Веган",
    filter_vegetarian: "Вегетариански",
    filter_top: "Популярни",
    add_to_cart: "Добави в кошницата",
    cart: "Кошница",
    your_order: "Вашата поръчка",
    empty_cart: "Кошницата е празна",
    total: "Общо",
    close: "Затвори",
    size: "Размер",
    sizes: "Размери",
    kids_menu_title: "Детско меню",
    kids_menu_short: "Детска пица, сок Cappy, палачинка и подарък",
    included_in_kids_menu: "Включено в детското меню",
    food_safety_notice: "Ястията са годни за консумация до 5 часа след сервирането и след това се отсервират.",
    quantity: "Количество",
    remove: "Премахни",
    currency: "лв.",
    items: "артикула",
    nav_home: "Начало",
    nav_menu: "Меню",
    footer_text: "Качествена италианска храна от 1995",
    follow_us: "Последвайте ни",
    language: "bg"
  }
};





